<template>
  <div class="common-page order-reassignment">
    <!--    <div class="line-separate"></div>-->
    <div class="left-box-content">
      <div class="content-box1">
        <div class="search-form-box">
          <el-row :gutter="30">
            <el-form inline>
              <el-col :span="5">
                <el-form-item label="装货地:">
                  <custom-city-cascader
                    :province-code="searchForm.loadProvinceCode"
                    :city-code="searchForm.loadCityCode"
                    :district-code="searchForm.loadDistrictCode"
                    @update:provinceCode="
                      (val) => (searchForm.loadProvinceCode = val)
                    "
                    @update:cityCode="(val) => (searchForm.loadCityCode = val)"
                    @update:districtCode="
                      (val) => (searchForm.loadDistrictCode = val)
                    "></custom-city-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="卸货地:">
                  <custom-city-cascader
                    :province-code="searchForm.unloadProvinceCode"
                    :city-code="searchForm.unloadCityCode"
                    :district-code="searchForm.unloadDistrictCode"
                    @update:provinceCode="
                      (val) => (searchForm.unloadProvinceCode = val)
                    "
                    @update:cityCode="
                      (val) => (searchForm.unloadCityCode = val)
                    "
                    @update:districtCode="
                      (val) => (searchForm.unloadDistrictCode = val)
                    "></custom-city-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="司机电话:">
                  <el-input
                    style="width: 100%"
                    clearable
                    v-model="searchForm.driverPhone"
                    autocomplete="off"
                    placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="货主电话:">
                  <el-input
                    style="width: 100%"
                    clearable
                    v-model="searchForm.ownerPhone"
                    autocomplete="off"
                    placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="下单时间:">
                  <custom-date-range
                    :start-date="searchForm.createTimeStart"
                    :end-date="searchForm.createTimeEnd"
                    @update:startDate="
                      (val) => (searchForm.createTimeStart = val)
                    "
                    @update:endDate="(val) => (searchForm.createTimeEnd = val)"></custom-date-range>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="">
                  <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                  <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
        <div
          class="custom-table-box"
          v-loading="tableOptions.loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.8)">
          <template v-if="tableData && tableData.length">
            <div
              class="table-list"
              :class="item.orderId === selectOrderId ? 'table-list-select' : ''"
              v-for="(item, index) in tableData"
              :key="item.orderId"
              @click="handleSelectOrder(item, index)">
              <div class="list-content-left">
                <div class="list-top">
                  <div class="list-top-left">
                    <div class="left-box" v-for="(item2, index) in item.pointList" :key="index">
                      <div class="left-box-top">
                        <div class="label" :class="item2.loadType === 1 ? 'zhuang' : 'xie'">
                          {{ item2.loadType === 1 ? "装" : "卸" }}
                        </div>
                        <div class="name">{{ item2.cityName }}{{ item2.districtName }}</div>
                      </div>
                      <!--                      <div class="date">-->
                      <!--                        <div>{{ $day.fd(item2.startTime, item2.endTime) }}</div>-->
                      <!--                        &lt;!&ndash;                        <div>{{ item2.endTime }}</div>&ndash;&gt;-->
                      <!--                      </div>-->
                    </div>
                  </div>
                  <div class="list-top-right">
                    <div class="right-box2">
                      <div class="right-box2-time">
                        <span>装货时间：{{ item.startLoadTime || "-"}}&nbsp;&nbsp;&nbsp;</span>
                        <span>下单时间：{{ item.createTime }}</span>
                        &nbsp;
                        <span>货主姓名：{{ item.ownerName }}</span>
                        &nbsp;
                        <span>货主电话：{{ item.ownerPhone }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-bottom">
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">物品</div>
                    <div class="bottom-box-value">
                      <!--                      {{ item.cargo.cargoName || "-" }}-->
                      <custom-tooltip :text="item.cargo.cargoName"></custom-tooltip>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">重量</div>
                    <div class="bottom-box-value">
                      {{ item.cargo.weight || "-" }}
                      {{ item.cargo.wightUnit === 1 ? "吨" : "公斤" }}
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">体积</div>
                    <div class="bottom-box-value">{{ item.cargo.volume || "-" }}㎡</div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">包装方式</div>
                    <div class="bottom-box-value">
                      {{ item.cargo.packingWays || "-" }}
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">用车要求</div>
                    <div class="bottom-box-value">
                      {{ item.vehicleUseType || "-" }}
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">车型</div>
                    <div class="bottom-box-value">
                      <custom-tooltip-multiple :text="item.vehicle?.vehicleMode"></custom-tooltip-multiple>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">车长</div>
                    <div class="bottom-box-value">
                      <!--                      <template v-if="item.vehicle?.vehicleLength">-->
                      <!--                        <span-->
                      <!--                          v-for="(item2, index) in item.vehicle?.vehicleLength"-->
                      <!--                          :key="index"-->
                      <!--                          >{{ item2 }}-->
                      <!--                          <span-->
                      <!--                            v-if="-->
                      <!--                              index !== item.vehicle?.vehicleLength.length - 1-->
                      <!--                            "-->
                      <!--                            >/</span-->
                      <!--                          ></span-->
                      <!--                        >-->
                      <!--                      </template>-->
                      <custom-tooltip-multiple :text="item.vehicle?.vehicleLength"></custom-tooltip-multiple>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">运费</div>
                    <div class="bottom-box-value">
                      <span class="money">{{ item.driverFee || "-" }}元</span>
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">承运车牌</div>
                    <div class="bottom-box-value">
                      {{ item.carNumber || "-" }}
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">司机</div>
                    <div class="bottom-box-value">
                      {{ item.driverName || "-" }}
                    </div>
                  </div>
                  <div class="list-bottom-box">
                    <div class="bottom-box-name">司机电话</div>
                    <div class="bottom-box-value">
                      {{ item.driverPhone || "-" }}
                    </div>
                  </div>
                </div>
                <div class="bottom-gai" v-if="item.reassignAuditing">
                  <i class="el-icon-warning colorFFD023"></i>
                  <span>
                    该笔订单已于{{ item.reassignTime }} 由{{
                      item.reassignUsername
                    }}
                  </span>
                  <span class="colorFFD023">发起改派司机审批</span>
                  <span class="color1269FF" @click="returnShenPi(item)">撤销审批</span>
                </div>
              </div>
              <div class="list-content-right">
                <div class="right-default" @click="openDetail(item)">订单详情</div>
                <div
                  class="right-primary"
                  :class="item.reassignAuditing ? 'disable' : ''"
                  @click="item.reassignAuditing ? '' : reassignmentDriver(item)">
                  改派司机
                </div>
              </div>
            </div>
          </template>
          <div class="no-data" v-else>
            <el-empty :image-size="100" description="暂无订单"></el-empty>
          </div>
        </div>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleSizeChange"
            :current-page="tableOptions.pageNumber"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="tableOptions.pageSize"
            background
            layout="total, prev, pager, next, sizes, jumper"
            :total="tableOptions.total" />
        </div>
      </div>
    </div>
    <cancel ref="cancel"></cancel>
    <reassignment ref="reassignment"></reassignment>
    <detail ref="detail" @refresh="refreshData"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import { getPage, rollbackReassign } from "./api";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import CustomSortBox from "@/components/customComponents/CustomSortBox.vue";
import cancel from "./cancel.vue";
import reassignment from "./reassignment.vue";
import detail from "@/views/OrderManagement/detail.vue";
import CustomCityCascader from "@/components/CustomCityCascader.vue";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    CustomTooltipMultiple,
    CustomTooltip,
    CustomCityCascader,
    CustomTabBox,
    CustomSortBox,
    OperateBox,
    CustomTable,
    CustomDateRange,
    cancel,
    detail,
    reassignment,
  },
  data() {
    return {
      loading: false,
      cheImage: require("@/assets/imgs/title.png"),
      getTableMethod: getPage,
      searchForm: {
        createTime: "",
        driverPhone: "",
        loadCityCode: "",
        loadDistrictCode: "",
        loadProvinceCode: "",
        ownerPhone: "",
        unloadCityCode: "",
        unloadDistrictCode: "",
        unloadProvinceCode: "",
      },
      isImmediatelyGetData: true,
      selectOrderId: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    refreshData() {
      this.tableOptions.currentPage = 1
      this.getTableData()
    },
    openDetail(item) {
      this.$refs.detail.init(item);
    },
    orderCancel(item) {
      this.$refs.cancel.init(item);
    },
    reassignmentDriver(item) {
      this.$refs.reassignment.init(item);
    },
    handleChange(val) {
      this.selectTab = val;
      this.$emit("changeTab", this.selectTab);
    },
    handleSelectOrder(item, index) {
      this.selectOrderId = item.orderId;
    },
    returnShenPi(item) {
      // 撤销
      this.$confirm(`确定撤销此改派审批？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        rollbackReassign(item.reassignId).then((res) => {
          if (res.code === 200) {
            this.$message.success("撤销成功");
            this.getTableData();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.order-reassignment {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  .money {
    font-size: 0.18rem;
    color: #faad14;
  }

  .left-box-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.2rem;
    box-sizing: border-box;
    border-radius: 0.08rem;

    .custom-table-box {
      //max-height: 90%;
      overflow-y: auto;
      padding-top: 0;

      .table-list {
        width: 100%;
        background: #fbfcff;
        margin-bottom: 0.2rem;
        padding: 0.12rem 0.1rem;
        box-sizing: border-box;
        border: 0.01rem solid #fbfcff;
        border-radius: 0.08rem;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        .list-content-left {
          flex: 1;
        }
        .list-content-right {
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          flex-shrink: 0;
          padding-top: 0.1rem;
          box-sizing: border-box;
          padding-left: 0.2rem;
          .right-default {
            width: 0.64rem;
            height: 0.21rem;
            border-radius: 0.04rem;
            background-color: #eaf1ff;
            color: #1269ff;
            font-size: 0.12rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 0.1rem;
          }
          .right-primary {
            width: 0.64rem;
            height: 0.21rem;
            border-radius: 0.04rem;
            background-color: #1269ff;
            color: #ffffff;
            font-size: 0.12rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .list-top {
          display: flex;
          justify-content: space-between;
          .list-top-left {
            display: flex;
            .left-box {
              padding-right: 0.5rem;
              position: relative;
              .left-box-top {
                display: flex;
                align-items: center;
                .label {
                  width: 0.2rem;
                  height: 0.2rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.02rem;
                  font-size: 0.12rem;
                }
                .zhuang {
                  color: #5cc41a;
                  background-color: rgba(92, 196, 26, 0.3);
                }
                .xie {
                  color: #e52019;
                  background-color: rgba(229, 32, 25, 0.3);
                }
                .name {
                  color: #000000;
                  font-size: 0.18rem;
                  line-height: 0.2rem;
                  padding-left: 0.04rem;
                }
              }
              .date {
                color: #8c8c8c;
                font-size: 0.12rem;
                line-height: 0.2rem;
              }
            }
            .left-box::before {
              content: "→";
              position: absolute;
              right: 0.15rem;
              top: 0.04rem;
              color: #52c41a;
            }
            .left-box:nth-last-of-type(1)::before {
              display: none;
            }
          }
          .list-top-right {
            .right-money {
              display: flex;
              justify-content: right;
              align-items: baseline;
              color: #faad14;

              .unit {
                font-size: 0.12rem;
                padding-left: 0.04rem;
              }
            }
            .right-box2 {
              display: flex;
              align-items: center;
              .right-box2-time {
                font-size: 0.12rem;
                line-height: 0.2rem;
                color: #8c8c8c;
                margin-right: 0.1rem;
              }
              .right-box2-label {
                background-color: #fff7e6;
                color: #fa8c16;
                font-size: 0.12rem;
                line-height: 0.22rem;
                border-radius: 0.1rem;
                padding: 0 0.1rem;
              }
            }
          }
        }
        .list-bottom {
          width: 100%;
          display: flex;
          padding: 0.12rem 0;
          .list-bottom-box {
            width: 15%;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            .bottom-box-name {
              color: #8c8c8c;
              font-size: 0.12rem;
              margin-bottom: 0.1rem;
            }
            .bottom-box-value {
              color: #434343;
              font-size: 0.14rem;
              text-align: center;
            }
          }
          .list-bottom-box::before {
            content: "";
            position: absolute;
            right: 0;
            top: 0.08rem;
            width: 0.01rem;
            height: 0.26rem;
            background-color: #dce5f5;
          }
          .list-bottom-box:nth-last-of-type(1)::before {
            display: none;
          }
        }
        .car-box {
          display: flex;
          align-items: center;
          border-top: 0.01rem dashed #dce5f5;
          padding: 0.1rem 0 0;
          .list-1 {
            display: flex;
            align-items: center;

            .label-img {
              width: 0.14rem;
              height: 0.14rem;
            }
            .center-name {
              line-height: 0.2rem;
              padding-left: 0.04rem;
              font-size: 0.14rem;
              color: #52c41a;
            }
          }
          .list-2,
          .list-3 {
            font-size: 0.12rem;
            color: #8c8c8c;
          }
          .list-2 {
            padding: 0 0.2rem;
            position: relative;
            &::before {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              left: 0.1rem;
            }
            &::after {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              right: 0.1rem;
            }
          }
        }
      }
      .table-list-select {
        border-color: #1269ff;
        background-color: rgba(18, 105, 255, 0.05);
      }
    }
    .pagination-box {
      display: flex;
      justify-content: right;
      padding: 0.2rem 0.2rem 0.2rem 0;
      background-color: #fff;
    }
  }
  .line-separate {
    width: 0.01rem;
    height: calc(100% - 0.4rem);
    background-color: rgba(220, 229, 245, 0.5);
    box-sizing: border-box;
    margin: 0.2rem 0.2rem 0.2rem 0;
  }
  .right-box {
    width: 30%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    padding: 0.2rem 0.2rem 0.2rem 0;
    .right-top {
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      padding-top: 0.2rem;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-title-tip {
        color: rgba(0, 0, 0, 0.25);
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding: 0.1rem 0;
      }
      .right-search {
        margin: 0.15rem 0 0;
      }
      .sort-car {
        padding: 0.1rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      padding-top: 0.2rem;
      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        padding: 0 0.1rem;
        box-sizing: border-box;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        overflow: hidden;
        position: relative;
        .label-box {
          position: absolute;
          right: 0;
          top: 0;
          border-radius: 0 0 0 0.08rem;

          width: 0.79rem;
          height: 0.29rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.12rem;
        }
        .label-box1 {
          background: rgba(250, 173, 20, 0.15);
          color: #faad14;
        }
        .label-box2 {
          background: rgba(82, 196, 26, 0.15);
          color: #52c41a;
        }
        .label-box3 {
          background: rgba(18, 105, 255, 0.15);
          color: #1269ff;
        }
        .center-box-name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0.1rem 0;
          .left-box {
            display: flex;
            align-items: center;
            .center-box-1 {
              display: flex;
              align-items: center;
              .label-name {
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #1269ff;
                font-size: 0.12rem;
                background-color: rgba(18, 105, 255, 0.05);
              }
              .center-name {
                line-height: 0.2rem;
                padding-left: 0.04rem;
              }
            }
            .center-box-2 {
              display: flex;
              align-items: center;
              line-height: 0.24rem;
              color: #000000;
              font-size: 0.12rem;
              position: relative;
            }
            .center-box-2 {
              padding-left: 0.2rem;
              position: relative;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                left: 0.1rem;
              }
            }
          }

          .center-box-3 {
            flex-shrink: 0;
            line-height: 0.2rem;
            font-size: 0.16rem;
            .default-icon {
              color: #eeeeee;
            }
            .selected-icon {
              color: #52c41a;
            }
          }
        }
        .center-box-car {
          border-top: 0.01rem dashed #dce5f5;
          .car-list {
            display: flex;
            align-items: center;
            padding: 0.08rem 0;
            .center-box-2 {
              padding-right: 0.2rem;
              color: #8c8c8c;
              position: relative;
              font-size: 0.12rem;
              &::before {
                content: "";
                width: 0.01rem;
                height: 0.1rem;
                background-color: #dce5f5;
                position: absolute;
                right: 0.1rem;
                top: 0.02rem;
              }
            }
            .center-box-2:nth-last-of-type(1)::before {
              display: none;
            }
          }
        }
        .car-operate {
          display: flex;
          justify-content: space-around;
          align-items: center;
          padding: 0.1rem 0;
          background-color: #f4f6fd;
          margin: 0 -0.1rem;
          .operate-list {
            display: flex;
            align-items: center;
            position: relative;
            .operate-img {
              width: 0.14rem;
              height: 0.14rem;
              margin-right: 0.02rem;
            }
            .operate-txt {
              font-size: 0.12rem;
              color: #434343;
            }
          }
          .operate-line {
            width: 0.01rem;
            height: 0.14rem;
            background-color: #e3e7ed;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
      }
    }
    .right-bottom-operate {
      width: 100%;
      flex-shrink: 0;
      position: sticky;
      bottom: 0rem;
      background-color: #ffffff;
      display: flex;
      justify-content: right;
      padding: 0.15rem 0;
      box-sizing: border-box;
      border-top: 0.01rem solid #e3e7ed;
    }
  }
  .tab-box {
    margin-bottom: 0.2rem;
  }
  .content-box1 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
  .content-box2 {
    width: 100%;
    height: 100%;
    border-radius: 0.08rem;
    overflow: hidden;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    padding: 0 0.2rem;
    box-sizing: border-box;
  }
  .bottom-gai {
    border-top: 0.01rem dashed #dce5f5;
    padding: 0.1rem 0 0;
    display: flex;
    align-items: center;
  }
  .color1269FF {
    padding-left: 0.2rem;
    &:hover {
      text-decoration: underline;
    }
  }
  .colorFFD023 {
    padding-left: 0.1rem;
    padding-right: 0.1rem;
  }
  .el-icon-warning {
    font-size: 0.2rem;
  }
}
</style>
